import React, { Component } from 'react';
import $ from 'jquery';
import { browserHistory, Link } from 'react-router';
import { ShareButtons,generateShareIcon } from 'react-share';
import { Panel } from 'react-bootstrap';
// import Swiper from 'react-id-swiper';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';


const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

// path="/web/:Bname/brand-details/:DType/:Bid"

export default class Web_About_Brand extends Component{
	constructor(props)
	{
		super(props);
		this.state={
			tot_data:[],
			products:[],
			cat:[],
			product_count:'',
			brand_details:'',
			load_more:'',
			brand_id:'',
			brand_name:'',
			type:'',
			dtype:'',
			share_msg:'',
			brand_location:'',
			logo:'',
			brand_bg:'',
			description:'',
			views_count:'',
			follow_count:'',
			brand_likes_count:'',
			deal_count:'',
			follow_status:'',
			like_status:'',
			page_loading:false,

			follow_status_flag:'',
			like_status_flag:'',
			open:false,
			brand_like_users:[],
			brand_like_rem_count:'',

			cat_active:'',
			like_load:false,
		};
		this.getBrandDetails=this.getBrandDetails.bind(this);
		this.tokenCheck=this.tokenCheck.bind(this);
		this.likeBrand=this.likeBrand.bind(this);
		this.FollowBrand=this.FollowBrand.bind(this);
		this.ShareFunc=this.ShareFunc.bind(this);
	    this.likeBrand_onLoad =this.likeBrand_onLoad.bind(this);
		this.getProducts =this.getProducts.bind(this);
	}
	componentDidMount()
	{
		window.scrollTo(0, 0);				
		localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
		
		if(screen.width < 800)
		{
			// window.location.href="/"+this.props.params.BrandName/*this.props.params.Bname+"/brand-details/"+this.props.params.DType+'/'+this.props.params.Bid;
		 	 window.location.href="/"+this.props.params.Bname+"/brand-details/"+this.props.params.Bid;					
		}
		// if(!localStorage.token && !localStorage.user_id)
		// {
		// 	localStorage.setItem('web_brand_details','/web/'+this.props.params.Bname+'/brand-details/'+this.props.params.DType+'/'+this.props.params.Bid);
		// 	browserHistory.push('/web/login');
		// }
		// else
		// {
			this.getBrandDetails();

		// }
		if(localStorage.user_id && localStorage.token && localStorage.web_likebrand)
		{
			this.likeBrand_onLoad();
		}
    }
    getProducts(catid)
    {
   	 if(localStorage.user_id)
   	 {
   	 	var uid =localStorage.user_id;
   	 }
   	 else
   	 {
   	 	 uid = 0;
   	 }
   	  var data1={from:'desktop_web',id:uid,token:localStorage.token,brand_id:this.props.params.Bid,cat_id:catid};
	  var data2=JSON.stringify(data1);
      $.ajax({
         url:baseUrl+'get_brandProductsByCat',
         method:'POST',
         dataType:'JSON',
         data:{req:data2},
         success:function(data)
         {
         	if(data.status === 'success')
         	{
              this.setState({products:data.products,cat_active:catid});
            }
         }.bind(this), 
         error:function(err)
         {

         }

      });
    }
	ShareFunc()
	{
		this.setState({
			open:!this.state.open,
		});
		setTimeout(() => {this.setState({open: false});}, 5000);
	}
	FollowBrand(status)
	{
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,brand_id:this.state.brand_id,status:status};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'follow_brand',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						follow_count:data.brand_follow_count,
						follow_status:data.follow_status,
					});
					if(data.follow_status===0)
					{
						this.setState({
							follow_status_flag:true,
						});
					}
					else
					{
						this.setState({
							follow_status_flag:false,
						});
					}
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	likeBrand(status)
	{
        if(!localStorage.user_id && !localStorage.token)
        {
           localStorage.setItem('web_brand_details','/web/'+this.props.params.Bname+'/brand-details/'+this.props.params.Bid);
			localStorage.setItem('web_likebrand','0');
			localStorage.setItem('status',status);
			browserHistory.push('/web/login');
        }
        else
        {
           this.setState({like_load:true});
           var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,brand_id:this.props.params.Bid,status:status};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'like_brand',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							like_status:data.like_status,
							brand_likes_count:data.brand_likes_count,
							brand_like_users:data.brand_like_users,
							like_load:false,
						});
					}
					if(data.like_status === 1)
					{
						this.setState({
							like_status_flag:true,
							like_load:false,
						});
					}
					else
					{
						this.setState({
							like_status_flag:false,
							like_load:false,
						});
					}
					localStorage.removeItem('status');
					localStorage.removeItem('web_likebrand');
					// this.getBrandDetails();
				}.bind(this),
				error:function(err)
				{
				}
			});
        }
    }
    likeBrand_onLoad()
    {
			this.setState({like_load:true});
			if(localStorage.status)
			{
				var status=localStorage.status;
			}
			else
			{
				status=1;
			}
			if(!localStorage.user_id && !localStorage.token)
			{
				localStorage.setItem('status',status);
			    localStorage.setItem('web_likebrand','1');
			    browserHistory.push('/web/login');
			}
			else
			{
				if(localStorage.user_id)
				{
					var uid = localStorage.user_id;
				}
				else
				{
					uid =0;
				}
				var data1={from:'desktop_web',id:uid,token:localStorage.token,brand_id:this.props.params.Bid,status:status};
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'POST',
					dataType:'json',
					url:baseUrl+'like_brand',
					data:{req:data2},
					success:function(data)
					{
						if(data.status==='success')
						{
							this.setState({
								like_status:data.like_status,
								brand_likes_count:data.brand_likes_count,
								brand_like_users:data.brand_like_users,
								like_load:false,
							});	
						}
						if(data.like_status===1)
						{
							this.setState({
								like_status_flag:true,
							});
						}
						else
						{
							this.setState({
								like_status_flag:false,
							});
						}
						localStorage.removeItem('status');
			            localStorage.removeItem('web_likebrand');
						// localStorage.removeItem('status');
						this.getBrandDetails();
					}.bind(this),
					error:function(err)
					{
					}
				});
	    }
	}
	tokenCheck()
	{
		localStorage.removeItem('user_id');
		localStorage.removeItem('token');
		window.location.reload();
	}
	getBrandDetails()
	{
		this.setState({
			page_loading:true,
		});
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,brand_id:this.props.params.Bid,page:'1'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'get_brand_details',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						tot_data:data,
						products:data.products,
						cat:data.cat,
						product_count:data.product_count,
						brand_details:data.brand_details,
						load_more:data.load_more,
						// brand_details start 
						brand_id:data.brand_details[0].brand_id,
						brand_name:data.brand_details[0].brand_name,
						type:data.brand_details[0].type,
						dtype:data.brand_details[0].dtype,
						share_msg:data.brand_details[0].share_msg,
						brand_location:data.brand_details[0].brand_location,
						logo:data.brand_details[0].logo,
						brand_bg:data.brand_details[0].brand_bg,
						description:data.brand_details[0].description,
						views_count:data.brand_details[0].views_count,
						follow_count:data.brand_details[0].follow_count,
						brand_likes_count:data.brand_details[0].likes_count,
						deal_count:data.brand_details[0].deal_count,
						follow_status:data.brand_details[0].follow_status,
						like_status:data.brand_details[0].like_status,
						brand_like_users:data.brand_like_users,
						brand_like_rem_count:data.brand_like_rem_count,
						// brand details end
						page_loading:false,
					});
					if(data.brand_details[0].follow_status==='1')
					{
						this.setState({
							follow_status_flag:false,
						});
					}
					else
					{
						this.setState({
							follow_status_flag:true,
						});	
					}
					if(data.brand_details[0].like_status==='1')
					{
						this.setState({
							like_status_flag:true,
						});
					}
					else
					{
						this.setState({
							like_status_flag:false,
						});
					}
				}
				 this.setState({cat_active:''});
				if(data.status==='error' && data.message==="Token mismatch")
				{
					this.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	render(){
		// const params = {
	 //      paginationClickable: true,
	 //      spaceBetween: 10,
	 //      slidesPerView: 3.3
	 //    }
		document.title=this.state.brand_details ? 'Buy '+this.state.brand_name +" Aqua Products Online | AquaDeals " : 'About the Brand | AquaDeals';
		var cat = this.state.cat.map(function(data,index){
          return(
            <li key={data.id} className={this.state.cat_active === data.id ? 'active' :''} onClick={()=>{this.getProducts(data.id)}}>
                <Link>
            	    <img src={baseAssets+'images/icons2/'+data.logo} width="30px" alt=" " />
                    <span>{data.name}:{data.count}</span>
                    <span></span>
                </Link>
            </li>
           );
        }.bind(this));
		var people_liked=<div className="web_brnd_liked_blk">
							<h5 className="web_abt_brnd_h5">People who liked</h5>
							<div className="web_brnd_liked_left">
								<p>Liked by {this.state.brand_likes_count === '1' ? this.state.brand_likes_count +' user' : this.state.brand_likes_count+' users'}</p>
								<div className="web_pro_liked_profile_blk">
									{this.state.brand_like_users.map(function(data,index){
										return(
											<i key={index} className="web_pro_liked_profile_icon"><img src={baseAssets+'images/pro_pics/'+data.pro_pic} alt=" " width="50px" /></i>
										)
									})}
									{this.state.brand_like_rem_count > 0 ? <span className="pro_liked_rem_count"><span>+{this.state.brand_like_rem_count}</span></span>: ''}
								</div>
							</div>
						</div>;
		var products = this.state.products.map(function(data,index){
			return(
				<div className="col-lg-3 col-md-3 col-sm-6  col-xs-3"> 
				<div className="prdt_blk">
					{data.dealcount >= 2 ?
						<div>
			                <Link to={"/web/subdeals/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_dtype+"/"+data.url_brand_name+"/"+data.pid} >
			                    {data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion} alt="" /></i> : ''}
			                    <div>
			                       <img  alt=" " src={data.image !==null && data.image !=='' ? data.image : baseAssets+'icons/web_icons/noImage.png'} />
			                    </div>
			                    {data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
			                    {/*data.dealcount >=2 ? <h4>{data.dealcount} deals available</h4> : <h4>&nbsp;</h4>*/}
			                    {/*data.pricediff ==="" ? <h4>MRP &#8377; {data.mrp}</h4> : <h4>&nbsp;</h4>*/}
							    {data.mrp ? <h4>MRP &#8377; {data.mrp}</h4>:<h4>&nbsp;</h4>}
							    {parseInt(data.count,10) > 0 ? <h4 className="webbrnd_view"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" alt=""/>&nbsp;{data.count} {data.count > 1 ? 'Views' : 'View'}</h4>:<h4>&nbsp;</h4>}
			                </Link>
						</div>
			        : 
			        <div>
		                <Link key={data.id} className='cursor' to={"/web/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.id} >
		                    {data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion} alt="" /></i> : ''}
		                    <div>
		                        <img alt=" " src={data.image !==null && data.image !=='' ? data.image : baseAssets+'icons/web_icons/noImage.png'}/>
		                    </div>
		                    {data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
		                    {/*{data.pricediff ?  <h4><span>AquaCash Discount</span>&nbsp;<span>&#8377;{data.pricediff}</span></h4> : ''}*/}
		                    {/*data.pricediff ==="" ? <h4>MRP &#8377; {data.mrp}</h4> : <h4>&nbsp;</h4>*/}
							{data.mrp ? <h4>MRP &#8377; {data.mrp}</h4>:<h4>&nbsp;</h4>}
							{parseInt(data.count,10) > 0 ? <h4 className="webbrnd_view"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" alt=""/>&nbsp;{data.count} {data.count > 1 ? 'Views' : 'View'}</h4>:<h4>&nbsp;</h4>}
			            </Link>
		            </div>
		        }
				</div>
			</div>
			)
		});
		// var following_btn=this.state.follow_status_flag ? <span className="web_pro_abt_follow_header_btn" onClick={()=>{this.FollowBrand(1)}}>Follow</span> : <span className="web_pro_abt_follow_header_btn_active" onClick={()=>this.FollowBrand(0)}>Following</span>;
		var likes_btn=this.state.like_status_flag ? <span className="brand_dtls_likes" onClick={()=>{this.likeBrand(0)}}><i className={"glyph_heart_active glyphicon glyphicon-heart"}></i>{this.state.brand_likes_count === '1' ? this.state.brand_likes_count+' Like' : this.state.brand_likes_count+' Likes'}</span>
									: <span className="brand_dtls_likes" onClick={()=>{this.likeBrand(1)}}><i className={"glyph_heart glyphicon glyphicon-heart"}></i>{this.state.brand_likes_count === '1' ? this.state.brand_likes_count+' Like' : this.state.brand_likes_count+' Likes'}</span>;
		var description_blk=this.state.description ? <div className="about_brand_dtls_blk" style={{marginBottom:'30px'}}>
								<h5 className="web_abt_brnd_h5"><span>About the brand</span><span style={{float:'right',marginRight:'5px',cursor:'pointer'}} onClick={()=>{this.ShareFunc()}}><i><img src={baseAssets+'mob-assets/share.png'} alt="share" width="19px" /></i></span></h5>
								<div>
									<Panel className="abt_brnd_panel" collapsible expanded={this.state.open}>
								        <FacebookShareButton url={'https://goo.gl/5dhJSM'} title={this.state.brand_name} description={this.state.share_msg} className="test_share1">
								            	<FacebookIcon size={32} round />
								        </FacebookShareButton>
								        <TwitterShareButton url={'https://goo.gl/5dhJSM'} title={this.state.brand_name} description={this.state.share_msg} className="test_share1">
								           	<TwitterIcon size={32} round />
								        </TwitterShareButton>
									    <GooglePlusShareButton url={'https://goo.gl/5dhJSM'} title={this.state.brand_name} description={this.state.share_msg} className="test_share1">
								           	<GooglePlusIcon size={32} round />
								        </GooglePlusShareButton>
							        </Panel>
							    </div>
								<div className="abt_brnd_desc">
									<p>{this.state.description}</p>
								</div>
							</div> : '';
								
		return(
			<div className="web_deals web_brand_details_page">
				{this.state.page_loading ? 
					<div className="loading_sym"><img src={baseAssets+'images/web_imgs/ajax-loader1.gif'} alt="Loading" /></div>
				:
					<div>
						<WebHeaderInner />
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>

						<section className="container Dels_cntnt">
							<div className="row">
								<div className="col-md-3">
									<div className="row del_lft">
										<h5 className={this.state.cat_active ? "fltr_title" : 'fltr_title active'} onClick={() => {this.getBrandDetails()}}>{this.state.brand_name ? this.state.brand_name : 'About the Brand'}</h5>
										<ul>
                                        	{cat}
                                    	</ul>
									</div>
								</div>
								<div className="col-md-9 del_rgt">
									<div className="del_rgt_blk">
										<div className="col-lg-12 col-md-12" style={{padding:'0px'}}>
										     {/*https://aquadeals.in/admin/assets/images//brand_backgrounds/xxxhdpi/20180126135243819741.jpg*/}                                         
											<div className="brand_dtls_blk" style={{textAlign:'center',backgroundImage:"url(https://aquadeals.in/admin/assets/images/"+this.state.brand_bg+")"}} >
												<i className="bg_img"><img src={baseAssets+'images/brand_icons/'+this.state.logo} alt=" " width="60px" /></i>
												<h5 className="web_brand_dtls_title">{this.state.brand_name ? this.state.brand_name : 'Brand Name:'}</h5>
												<div>
													<div className="col-lg-4 col-md-4 web_brand_views_blk"><span className="web_views_item"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" alt=" " />&nbsp;{this.state.views_count === 1 ? this.state.views_count+ ' View' : this.state.views_count+' Views'}</span></div>
													<div className="col-lg-4 col-md-4" style={{padding:'0px',textAlign:'center'}}>
														<a className="brand_dtls_shop_btn" href={'/web/pdeals/brands/'+this.state.tot_data.url_brand_name+'/'+this.props.params.Bid}>SHOP BRAND</a>
														{/*<a className="brand_dtls_shop_btn" href={'/web/pdeals/'+this.state.tot_data.url_dtype_name+'/'+this.state.tot_data.url_brand_name+'/'+this.props.params.Bid+'/brand/'+this.props.params.DType}>SHOP BRAND</a>*/}
													</div>
													<div className="col-lg-4 col-md-4">
														{likes_btn}
													</div>
												</div>
											</div>
										</div>
										<div className="clr">&nbsp;</div>
										<div className="itm_lst">
											<div>
												{description_blk}
											</div>
											{people_liked && this.state.brand_likes_count > 0 ? people_liked : ''}
											{products.length > 0 ? products : ''}
										</div>
									</div>
									{this.state.like_load ? <div className="web_loading"><img src={baseAssets+'images/loading_more.gif'} role="presentation" width='40px' /></div> :''}
								</div>
							</div>
						</section>
						<div className="clr"></div>
                		<WebFooter />
					</div>
				}
			</div>	
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Brands/Web_About_Brand.js
 **/